import { Button } from '@/components/ui/button'
import { useEstateMediaTypes } from '@/estate/hooks/useEstateMediaTypes'
import { EstateMedia } from '@/estateMedia/components/EstateMedia/EstateMedia'
import { EstateMediaFileUploadDialog } from '@/estateMedia/components/EstateMedia/EstateMediaFileUploadDialog'
import { useEstateMedias } from '@/estateMedia/hooks/useEstateMedias'
import { Estate_Media_Type_Group_Enum, Estate_Media_Type_Name_Enum } from '@gql'
import React, { useMemo, useState } from 'react'
import { useTranslation } from 'react-i18next'

export type EstateDiagnosticsMediaListProps = {
  estateId: string
  readonly: boolean
}
export const EstateDiagnosticsMediaList = ({
  estateId,
  readonly,
}: EstateDiagnosticsMediaListProps) => {
  const { t } = useTranslation()

  const { estateMediaTypes } = useEstateMediaTypes({
    group: Estate_Media_Type_Group_Enum.Diagnostics,
  })
  const estateMediaTypeDiagnosticOther = useMemo(() => {
    return estateMediaTypes.find(
      (type) => type.name === Estate_Media_Type_Name_Enum.Other
    )
  }, [estateMediaTypes])

  const [open, setOpen] = useState(false)

  const handleFileUpload = () => {
    setOpen(false)
  }

  const { estateMedias: allEstateMedias } = useEstateMedias({
    estateId: estateId,
    typeGroup: Estate_Media_Type_Group_Enum.Diagnostics,
  })

  const estateMedias = allEstateMedias.filter((em) => !em.isCensored)

  return (
    <div className="tw-flex tw-flex-col tw-gap-4">
      {estateMedias.map((estateMedia) => (
        <EstateMedia
          key={estateMedia.id}
          estateId={estateId}
          estateMedia={estateMedia}
          canSetCustomName={true}
          readonly={readonly}
        />
      ))}
      {!readonly && (
        <>
          <div className="tw-bg-gray-100 tw-flex tw-flex-row tw-gap-4 tw-items-center tw-justify-between tw-rounded-lg tw-p-4">
            <div>{t('EstateMedias.addFile')}</div>
            <Button variant="outline" onClick={() => setOpen(true)}>
              {t('common.add')}
            </Button>
          </div>
          <EstateMediaFileUploadDialog
            estateId={estateId}
            showToasts={true}
            open={open}
            onOpenChange={setOpen}
            type={estateMediaTypeDiagnosticOther!}
            onUpload={handleFileUpload}
            canSetCustomName={true}
          />
        </>
      )}
    </div>
  )
}
